import Cookies from 'js-cookie';
import Sortable from "sortablejs";

const launch_search_modal_window = function(kind, target_value_element, target_label_element) {
    let $modal = $('#' + kind + '_modal_search');
    $modal.find('.target_label_element').val(target_label_element);
    $modal.find('.target_value_element').val(target_value_element);
    $modal.find('.submit_modal_search_form_clear').click();
    $modal.modal('show');
};

document.addEventListener("turbolinks:load", function (e) {

    // メニューのディレクトリ内に利用可能な権限のアプリがない場合は、ディレクトリを非表示
    $('.menu_dir').each(function(i,el) {
        if ($(el).find('.menu_app_link').length === 0) {
            $(el).hide();
        }
    })

    $('body').on('click', '.clear_modal_value', function() {
        $($(this).data('value-element')).val('').change();
        $($(this).data('label-element')).val('').change();
        return false;
    });

    $('body').on('click', '.launch_search_modal_window', function(){
        launch_search_modal_window($(this).data('modal-kind'), $(this).data('value-element'), $(this).data('label-element'));
        return false;
    });


    $('body').on('click', '.row_delete', function() {
        let $self = $(this);
        let _destroy = $self.parent().find('._destroy');
        if (_destroy.prop('checked')) {
            _destroy.prop('checked', false);
            $self.removeClass('text-danger');
        } else {
            if (confirm('削除対象としてよろしいでしょうか？')) {
                _destroy.prop('checked', true);
                $self.addClass('text-danger');
            }
        }
    });

    $('body').on('click', '.row_delete_unsaved', function() {
        if (confirm('削除してよろしいでしょうか？')) {
            let row = $(this).parents('tr');
            row.remove();
        }
    });

    $('body').on('click', '.btn_comment_edit_toggle', function() {
        $(this).parents('.comment').find('.comment_toggle').toggle();
    });

    $('body').on('click', '.btn_time_now', function() {
        let now = new Date();
        $(this).parents('.timepicker').find('.form-control').val(now.getHours() + ':' + ( '00' + now.getMinutes() ).slice( -2 ))
    })

    $('.close_left_conditions').on('click', function() {
        let left_conditions = $(this).parents('.left_conditions');
        let right_results = left_conditions.next('.right_results');
        left_conditions.hide('fast', function() {
            right_results.find('.open_left_conditions').removeClass('d-none');
        });
        Cookies.set('left_conditions', 'hide');
    });

    $('.open_left_conditions').on('click', function() {
        let self = $(this);
        let right_results = self.parents('.right_results');
        let left_conditions = right_results.prev('.left_conditions');
        self.addClass('d-none');
        left_conditions.show('fast');
        Cookies.set('left_conditions', 'show');
    });

    let left_conditions = Cookies.get('left_conditions');
    if (left_conditions === 'hide') {
        $('.left_conditions').hide();
        $('.open_left_conditions').removeClass('d-none');
    }

    let hsize = $(window).height() - 250;
    $("main").css("height", hsize + "px");
    $(".table_wrapper").css("height", hsize - 80 + "px");
    $(".modal_search_dialog .modal-content .table_wrapper").css("height", hsize - 300 + "px");

    set_sortable(document.getElementsByClassName('sortable_table'));

    // 検索結果のソート順
    $('table.search_result_table').find('.sortable').click(function() {
        let form = $('form.search_form');
        let $order_column = form.find('.order1_column');
        let request_order_column = $(this).data('column_name');
        let $order_kind = form.find('.order1_kind')
        if ($order_column.val() === request_order_column) {
            $order_kind.val($order_kind.val() === 'asc' ? 'desc' : 'asc');
        } else {
            $order_column.val(request_order_column)
            $order_kind.val('asc')
        }
        form.submit();
    });

    // 行追加ボタン
    $('body').on('click', '.btn_bulk_new', function() {
        let self = $(this);
        let wrapper = self.parents('.bulk_new_wrapper');
        let size = wrapper.find('.bulk_size').val();
        let url = wrapper.data('bulk_new_url');
        let current_size = $(wrapper.data('add_class')).length;
        $.ajax({
            type: 'GET',
            url: url,
            data: { size: size, current_size: current_size, column_idx: wrapper.data('column_idx') },
            dataType: 'script'
        })
    });
});

// エンターキーでのsubmit制御
// https://qiita.com/awakia/items/17457d6b1809dd803413
$(function() {
    $(document).on("keypress", "input:not(.allow_submit)", function(event) {
        let $form = $(this).closest('form');
        if ($form.attr('method') === 'get' || $form.hasClass('login_form')) return true;
        return event.which !== 13;
    });
});

// ドラッグ＆ドロップでのソート
let set_sortable = function(els) {
    if (els == null) return;
    Array.from(els).forEach(function(el) {
        Sortable.create(el, {
            animation: 300,
            handle: ".drag_handle",
            onEnd: function (/**Event*/evt) {
                $(evt.to).find('.hidden_seq').each(function (index) {
                    $(this).val(index + 1);
                });
            }
        });
    })
}